<div class="light-control-host">
  @if (createNewUser) {
    <form [formGroup]="createUserForm" (ngSubmit)="createUserButtonClick()" data-cy="form-create-user">
      <h3 class="panel-title">Start your free 30-day {{ uiService.productName }} trial</h3>
      <div class="flex-center-column margin-top">
        <div class="flex-center-row full-width">
          <input
            id="display-name"
            class="arpio-input"
            data-cy="form-input-display-name"
            type="text"
            formControlName="displayName"
            placeholder="Your name"
            autocomplete="name"
            focus-element
          />
        </div>
        <div class="flex-center-row full-width">
          <input
            id="email"
            class="arpio-input"
            data-cy="form-input-email"
            type="text"
            formControlName="email"
            placeholder="Email"
            autocomplete="username"
          />
        </div>
        <div class="flex-center-row full-width field-issue-container">
          <input
            id="password"
            class="arpio-input"
            data-cy="form-input-password"
            type="password"
            formControlName="password"
            placeholder="Password"
            autocomplete="new-password"
          />
          @if (!!passwordError) {
            <arp-field-issue [message]="passwordError"></arp-field-issue>
          }
        </div>
        <div class="flex-center-row full-width field-issue-container">
          <input
            id="confirm-pword"
            class="arpio-input"
            data-cy="form-input-confirm-pword"
            type="password"
            formControlName="confirmPassword"
            placeholder="Confirm password"
            autocomplete="new-password"
          />
          @if (!!confirmPasswordError) {
            <arp-field-issue [message]="confirmPasswordError"></arp-field-issue>
          }
        </div>
        <div id="tos-checkbox" class="flex-center-row full-width">
          <input
            id="agree-to-terms"
            class="arpio-checkbox"
            data-cy="form-input-agree-to-terms"
            type="checkbox"
            formControlName="agreeToTerms"
          />
          <div class="spacer">
            I agree to the {{ uiService.productName }}
            <a target="_blank" [href]="uiService.termsOfServiceUrl">terms of service.</a>
          </div>
        </div>
        <button
          busy-button
          [busy]="submitting"
          class="arpio-button"
          data-cy="button-submit-register"
          type="submit"
          [disabled]="!createUserForm.valid || submitting"
        >
          Get Started
        </button>
        @if (formError) {
          <arp-error-block class="form-level-error" variant="row" [error]="formError"></arp-error-block>
        }
        <div class="padding-top">
          Already have an {{ uiService.productName }} account?
          <a href (click)="$event.preventDefault(); toggleView()" data-cy="link-toggle-login2">Log in</a>
        </div>
      </div>
    </form>
  } @else {
    <form [formGroup]="loginUserForm" (ngSubmit)="loginButtonClick()">
      <h3 class="panel-title">Log in to {{ uiService.productName }}</h3>
      <div class="flex-center-column margin-top">
        <div class="flex-center-row full-width">
          <input
            id="email"
            class="arpio-input"
            type="text"
            formControlName="email"
            placeholder="Email"
            autocomplete="username"
            focus-element
          />
        </div>
        <div class="flex-center-row full-width">
          <input
            id="login-pword"
            class="arpio-input"
            type="password"
            formControlName="password"
            placeholder="Password"
            autocomplete="current-password"
          />
        </div>
        <button
          busy-button
          [busy]="submitting"
          class="arpio-button"
          type="submit"
          [disabled]="!loginUserForm.valid || submitting"
        >
          Login
        </button>
        @if (formError) {
          <arp-error-block class="form-level-error" variant="row" [error]="formError"></arp-error-block>
        }
        <div class="padding-top">
          Need an {{ uiService.productName }} account?
          <a href (click)="$event.preventDefault(); toggleView()">Sign up</a>
        </div>
        <div class="padding-top" id="forgot-password">
          <a [routerLink]="uiService.buildResetPasswordUrl()">Forgot your password?</a>
        </div>
      </div>
    </form>
  }
</div>
